export default __webpack_public_path__ + "static/media/Hammer of Dreams.bfac17fb.jpg";